/**
 * @Description 发送语音验证码
 */
import { FC, useState } from 'react';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import { V2Confirm } from '@/common/components/Others/V2Confirm';
import { MOBILE_REG } from '@lhb/regexp';
import { sendVoiceCode } from '@/common/api/login';
import styles from './index.module.less';

const VoiceCaptcha: FC<any> = ({ form }) => {
  const [isLock, setIsLock] = useState<boolean>(false);

  const onVoiceCaptcha = () => {
    const values = form.getFieldsValue();
    const { mobile } = values;
    if (!mobile) {
      V2Message.warning('请输入手机号');
      return;
    }
    if (!MOBILE_REG.test(mobile)) {
      V2Message.warning('手机号格式错误');
      return;
    }
    const formattedStr = formattedMobile(mobile);
    const strArr = [
      `1. 确认手机号 ${formattedStr} 是否填写正确`,
      '2. 检查短信是否被安全软件拦截',
      '3. 使用语音验证码',
      '4. 为防止骚扰用户、国内（+86号码段）每天22:00至次日7:30禁止发送语音验证码。',
      '5. 为保证正常收到验证码，手机请勿设置拦截骚扰电话。',
      '6. 确认发送语音验证码后请及时接听，切勿挂断。',
    ];

    V2Confirm({
      onSure: (modal: any) => onSure(modal, mobile),
      title: '收不到验证码',
      content: <div className={styles.voiceConfirmContent}>
        {strArr.map((itm, idx) => (<div key={idx} className={idx ? 'mt-8' : ''}>{itm}</div>))}
      </div>,
      okText: '发送语音验证码',
    });
  };

  /**
   * @description 手机号第3位、第7位后加空格
   * @param str 输入的手机号
   * @return 加空格后的字符串
   */
  const formattedMobile = (str: string) => {
    const front = str.length >= 3 ? str.slice(0, 3) : str;
    const center = str.length >= 7 ? str.slice(front.length, 7) : str.slice(front.length, str.length);
    const end = str.slice(front.length + center.length, str.length);
    return [front, center, end].join(' ');
  };

  /**
   * @description 点击发送按钮
   * @param modal
   * @param mobile
   */
  const onSure = (modal: any, mobile: string) => {
    if (isLock) return;
    setIsLock(true);
    sendVoiceCode({ mobile }).then(() => {
      V2Message.success('发送成功');
    }).finally(() => {
      setIsLock(false);
      modal.destroy();
    });
  };

  return (
    <div className={styles.unableReceive} onClick={() => onVoiceCaptcha()}>
      收不到验证码？
    </div>
  );
};

export default VoiceCaptcha;
